import React from 'react';
import PropTypes from 'prop-types';
import { mediaTypes } from 'components/posts';

const ContentType = ({ type }) => {
    let iconName = '';

    switch (type) {
        case mediaTypes.VIDEO_PLAYER:
            iconName = 'play';
            break;
        case mediaTypes.GALLERY:
            iconName = 'gallery';
            break;
        default:
            iconName = '';
    }

    return (
        <div className="content-type-video">
            <svg className="content-type-video__icon icon" width="20px" height="20px" focusable="false">
                <use xlinkHref={`#icon-${iconName}`}></use>
            </svg>
        </div>
    );
};

ContentType.propTypes = {
    type: PropTypes.string
};

export default ContentType;
